import { useEffect, useState } from 'react';
import Layout from '../components/Layout.jsx';
import { api } from '../api.js';

const fmt = (n) => '$ ' + new Intl.NumberFormat('es-CO').format(n ?? 0);

export default function Reportes() {
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [reporte, setReporte] = useState(null);

  const cargar = async () => {
    const r = await api.reporteDia(fecha);
    setReporte(r);
  };
  useEffect(() => { cargar(); }, [fecha]);

  const t = (tipo) => reporte?.totales?.find((x) => x.tipo === tipo) ?? { n: 0, monto: 0, cantidad: 0 };
  const ventas = t('venta');
  const cortesias = t('cortesia');
  const mermas = t('merma');
  const reposiciones = t('reposicion');

  return (
    <Layout>
      <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
        <div>
          <p className="eyebrow mb-2">Cierre del día</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Reporte diario</h1>
        </div>
        <div className="card-flat p-4 flex items-center gap-4">
          <span className="eyebrow">Fecha</span>
          <input className="input max-w-[180px] py-2 px-3 text-base" type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
        </div>
      </div>

      <div className="card-ink mb-6 grain relative overflow-hidden">
        <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full opacity-25 blur-3xl pointer-events-none" style={{ background: 'radial-gradient(closest-side, #C8E847, transparent)' }} />
        <div className="relative">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-lime mb-3">Ingresos brutos</p>
          <div className="text-5xl md:text-6xl font-bold tracking-tight">{fmt(ventas.monto)}</div>
          <div className="font-mono text-sm text-paper/70 mt-3">{ventas.n ?? 0} ventas · {ventas.cantidad ?? 0} unidades vendidas</div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="card-lime relative overflow-hidden">
          <div className="flex items-start justify-between mb-4">
            <p className="eyebrow">Cortesías oficina</p>
            <span className="text-2xl">☕</span>
          </div>
          <div className="text-3xl font-semibold tracking-tight">{cortesias.cantidad ?? 0} ud</div>
          <div className="font-mono text-[11px] text-muted mt-2">{cortesias.n ?? 0} entregas internas</div>
        </div>

        <div className="card-flat bg-bone/60">
          <div className="flex items-start justify-between mb-4">
            <p className="eyebrow">Mermas</p>
            <span className="text-2xl">🚯</span>
          </div>
          <div className="text-3xl font-semibold tracking-tight">{mermas.cantidad ?? 0} ud</div>
          <div className="font-mono text-[11px] text-muted mt-2">{mermas.n ?? 0} reportes</div>
        </div>

        <div className="card-flat bg-bone/60">
          <div className="flex items-start justify-between mb-4">
            <p className="eyebrow">Reposiciones</p>
            <span className="text-2xl">📦</span>
          </div>
          <div className="text-3xl font-semibold tracking-tight">{reposiciones.cantidad ?? 0} ud</div>
          <div className="font-mono text-[11px] text-muted mt-2">{reposiciones.n ?? 0} entradas</div>
        </div>
      </div>
    </Layout>
  );
}
